import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Steps = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Steps' {...props}>
    <polygon fill='none' stroke='#000' strokeWidth='2' points='16 6 11 6 11 11 6 11 6 16 1 16 1 23 23 23 23 1 16 1' />
  </StyledIcon>
);
